import React from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';
import { isMobile, isTablet } from 'react-device-detect'
import { CartesianGrid, Line, LineChart, ResponsiveContainer, Tooltip, XAxis } from 'recharts';

function CustomizeDot(p) {
  return (
    <circle
      r="3"
      stroke={p.stroke}
      fill={p.stroke}
      strokeWidth="4"
      width="574"
      height="120"
      className="recharts-dot recharts-line-dot"
      cx={p.cx}
      cy={p.cy} />
  )
}

function CustomizedCursor(p) {
  const { t } = useTranslation();
  if (!p.active) return null;
  let data = p.payload;
  const dom = document.getElementById("defaultTooltipBox");
  if (dom) {
    dom.style.display = "none";
  }

  return (
    <div
      className="chartTooltipBox"
      // style="position: absolute; bottom: 20px; left: 50%"
    >
      <p className="tit">{`${p.label}(${data[0].payload.lrnPrgsStsCdNm})`}</p>
      <p className="txt">{t("LC_05_07_03.msg009")} : {data[0].payload.cransrAvg}%</p>
      <p className="txt">{t("LC_05_07_03.msg002")} : {data[0].payload.explAcrcyRt}%</p>
      <p className="txt">{t("LC_05_07_03.msg005")} : {data[0].payload.explSpedCd}</p>
    </div>
  )
}

function ResultChartV2({ lrnCmnResList }) {
  const { t } = useTranslation();
  // let count = 1;
  let data = lrnCmnResList;
  let cartData = [];
  let lastData = null;

  if (lrnCmnResList.length > 10) {
    // count = lrnCmnResList.length - 9; // 90
    data = lrnCmnResList.splice(lrnCmnResList.length - 10, 10);
  }

  data.forEach((item, index) => {

    cartData.push({
      // name: `${count + index}회`,
      name: `${item.lrnTmeSn}${i18n.language === 'ko' ? '회' : ''}`,
      speed: item.explSped,
      cransrAvg: item.cransrAvg,
      explAcrcyRt: item.explAcrcyRt,
      explSpedCd: item.explSpedCdNm,
      lrnPrgsStsCdNm: item.lrnPrgsStsCdNm,
    });

    if (index + 1 === data.length) {
      lastData = {
        // name: `${count + index}회(${item.lrnPrgsStsCdNm})`,
        name: `${item.lrnTmeSn}${i18n.language === 'ko' ? '회' : ''}(${item.lrnPrgsStsCdNm})`,
        speed: item.explSped,
        cransrAvg: item.cransrAvg,
        explAcrcyRt: item.explAcrcyRt,
        explSpedCd: item.explSpedCdNm,
        lrnPrgsStsCdNm: item.lrnPrgsStsCdNm,
      }
    }
  });

  return (
    <React.Fragment>
      <div
        id="defaultTooltipBox"
        className="chartTooltipBox"
        style={{
          position: 'absolute',
          bottom: '45px',
          left: (isMobile && !isTablet) ? '40%' : '70%',
          zIndex: 1
        }}
      >
        <p className="tit">{lastData.name}</p>
        <p className="txt">{t("LC_05_07_03.msg009")} : {lastData.cransrAvg}%</p>
        <p className="txt">{t("LC_05_07_03.msg002")} : {lastData.explAcrcyRt}%</p>
        <p className="txt">{t("LC_05_07_03.msg005")} : {lastData.explSpedCd}</p>
      </div>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart
          data={cartData}
          margin={{ top: 5, right: 30, left: 20, bottom: 5 }}
        >
          <CartesianGrid
            vertical={false}
          />
          <Tooltip
            cursor={false}
            content={<CustomizedCursor />}
          />
          <XAxis
            dataKey="name"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#96a0aa' }}
            
          />
          {/* <YAxis axisLine={false} tickLine={false} tick={{fill: '#ffffff'}}/> */}
          <Line
            dataKey="speed"
            stroke="#ff6e5f"
            strokeWidth={4}
            dot={<CustomizeDot />}
          />
          <Line
            dataKey="cransrAvg"
            stroke="#f5b400"
            strokeWidth={4}
            strokeDasharray="10 10"
            dot={<CustomizeDot />}
          />
          <Line
            dataKey="explAcrcyRt"
            stroke="#32a0ff"
            strokeWidth={4}
            dot={<CustomizeDot />}
          />
        </LineChart>
      </ResponsiveContainer>

    </React.Fragment>
  );
}

export default ResultChartV2;